import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import generateEventDiff from './generateEventDiff';

/**
 * Returns if the event is dirty (updated by the user) based on the original event
 */
export default function isDirty(
    event: CalendarEvent,
    originalEvent: CalendarEvent,
    shouldIgnoreAttachments: boolean,
    shouldIgnoreParentFolderId?: boolean
): boolean {
    let diffEvent = generateEventDiff(event, originalEvent);
    let changesCount = Object.keys(diffEvent).length;

    if (shouldIgnoreAttachments) {
        // Adding/deleting attachments results in change to ItemId changekey
        // so ignore ItemId changes
        changesCount -= (diffEvent.Attachments ? 1 : 0) + (diffEvent.ItemId ? 1 : 0);
    }

    if (shouldIgnoreParentFolderId) {
        // Ignore the parent folder id when checking whether to display the 'Reset form' dialog
        changesCount -= diffEvent.ParentFolderId ? 1 : 0;
    }

    if (diffEvent.hasOwnProperty('IsOnlineMeeting')) {
        changesCount -= diffEvent.IsOnlineMeeting == originalEvent.IsOnlineMeeting ? 1 : 0;
    }

    if (diffEvent.hasOwnProperty('OnlineMeetingProvider')) {
        changesCount -=
            diffEvent.OnlineMeetingProvider == originalEvent.OnlineMeetingProvider ? 1 : 0;
    }

    return changesCount > 0; // If we have any changes, then it is dirty
}
